<div class="wrapper">
    <div>
        <app-verticals-banner></app-verticals-banner>
    </div>

    <div>
        <app-verticals-content></app-verticals-content>
    </div>
</div>